import { __awaiter, __generator } from "tslib";
import '../polyfill';
import { reportHomePageLoadedDuration, reportHomePagePaintDuration } from '../../logger/homePageLoad';
import { fetchHandleError } from '../FetchConfig';
import { appDataInitialize, bootstrap } from './bootstrap';
fetchHandleError();
window.addEventListener('load', function () {
    reportHomePageLoadedDuration();
    reportHomePagePaintDuration();
});
appDataInitialize();
window.addEventListener('DOMContentLoaded', function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        bootstrap();
        return [2];
    });
}); });
